import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "@/plugins/axios";
import "lib-flexible/flexible";
import { Toast, Dialog, Popup, Field, CellGroup, List } from "vant";
import debounceInput from "./utils/inputDebounce";
// import Vconsole from "vconsole";
// new Vconsole();
require("@/plugins/default-passive-events");
import waterfall from "vue-waterfall2";

const app = createApp(App);
app
  .use(store)
  .use(router)
  .use(axios)
  .use(Toast)
  .use(Popup)
  .use(Field)
  .use(List)
  .use(CellGroup)
  .use(Dialog)
  .use(waterfall)
  // .use(vConsole)
  .mount("#app");
app.provide("$toast", app.config.globalProperties.$toast);
app.provide("$dialog", app.config.globalProperties.$dialog);
app.directive("debounceInput", debounceInput);
app.config.compilerOptions.isCustomElement = (tag) => {
  return tag.startWith("wx-open-launch-app");
};
import(
  /* webpackChunkName: "sensors" */
  "sa-sdk-javascript"
).then((sensors) => {
  let project = "xhlcs",
    origin = location.origin;
  if (origin.indexOf("dev") > -1 || origin.indexOf("test") > -1) {
    project = "xhlcstest";
  }
  sensors.init({
    show_log: false,
    server_url: "https://sadata.yixin.com/sa?project=" + project,
    heatmap: {
      clickmap: "default", //自动采集 $WebClick 事件
      scroll_notice_map: "default", //注意力图 $WebStay事件,
      collect_tags: {
        div: {
          ignore_tags: [
            "mark",
            "strong",
            "b",
            "em",
            "i",
            "u",
            "abbr",
            "ins",
            "del",
            "s",
            "sup",
            "span",
          ],
        },
      },
    },
    is_track_single_page: true,
    app_js_bridge: {
      // 开启APP打通
      white_list: [
        "https://sadata.yixin.com/sa?project=xhlcstest",
        "https://sadata.yixin.com/sa?project=xhlcs",
        "https://sadata.xinghuo365.com/sa?project=xhjf",
        "https://sadata.xinghuo365.com/sa?project=xhjftest",
        "https://sadata.yixin.com/sa?project=puzejijin_test",
        "https://sadata.yixin.com/sa?project=puzejijin_production",
      ],
    },
  });
  sensors.registerPage({
    app_source: "予能",
  });
  sensors.quick("autoTrack");
  // app.prototype.$sensors = sensors;
});
